import { get, isNaN } from 'lodash';
import { trims } from 'utils';
import * as Yup from 'yup';

Yup.addMethod(Yup.string, 'uniqueField', function (parent: string) {
  // @ts-ignore
  return this.test('uniqueField', parent, function (obj: string) {
    // @ts-ignore
    const { value } = this.from[1];
    const list = get(value, parent);

    const fieldName = this.path.split('.')[1];

    const uniqValues = [] as any[];
    const doubles = [] as any[];

    if (parent === 'configurations' || parent === 'locations') {
      list.forEach((doc: any) => {
        const val = trims(String(doc.name)?.toLocaleLowerCase());

        if (uniqValues.includes(val) && !doubles.includes(val)) {
          doubles.push(val);
        }
        if (!uniqValues.includes(val)) {
          uniqValues.push(val);
        }
      });
    } else {
      list.forEach((doc: any) => {
        const val = trims(String(doc[fieldName])?.toLocaleLowerCase());

        if (uniqValues.includes(val) && !doubles.includes(val)) {
          doubles.push(val);
        }
        if (!uniqValues.includes(val)) {
          uniqValues.push(val);
        }
      });
    }

    if (!doubles.includes(trims(obj?.toLocaleLowerCase()))) return true;
    return this.createError({
      path: this.path,
      message: 'Вже є у списку',
    });
  });
});

Yup.addMethod(Yup.string, 'uniqueTemplates', function (parent: string) {
  // @ts-ignore
  return this.test('uniqueTemplates', parent, function (obj: string) {
    // @ts-ignore
    const { value } = this.from[1];
    const list = get(value, parent);

    const fieldName = this.path.split('.')[1];

    const uniqValues = [] as any[];
    const doubles = [] as any[];

    if (parent === 'driverTemplates' || parent === 'clientTemplates') {
      list.forEach((doc: any) => {
        const val = trims(String(doc.causeSendingMessageId)?.toLocaleLowerCase());
        if (uniqValues.includes(val) && !doubles.includes(val)) {
          doubles.push(val);
        }
        if (!uniqValues.includes(val)) {
          uniqValues.push(val);
        }
      });
    } else {
      list.forEach((doc: any) => {
        const val = trims(String(doc[fieldName])?.toLocaleLowerCase());

        if (uniqValues.includes(val) && !doubles.includes(val)) {
          doubles.push(val);
        }
        if (!uniqValues.includes(val)) {
          uniqValues.push(val);
        }
      });
    }

    if (!doubles.includes(obj)) return true;

    return this.createError({
      path: this.path,
      message: 'Вже є у списку',
    });
  });
});

const branchEditingSchema = Yup.object().shape({
  id: Yup.number(),
  name: Yup.string().trim().min(1, "Обов'язкове поле").required(`Обов'язкове поле`),
  operatingProcedure: Yup.string().required("Обов'язкове поле"),
  address: Yup.string().trim().min(1, "Обов'язкове поле").required("Обов'язкове поле"),
  aadRoles: Yup.array().of(
    Yup.object().shape({
      id: Yup.number(),
      roleId: Yup.number().required("Обов'язкове поле"),
      title: Yup.string().required("Обов'язкове поле"),
      objectId: Yup.string()
        .nullable()
        .max(50, 'Максимальна довжина 50 символів')
        // @ts-ignore
        .uniqueField('aadRoles')
        .required("Обов'язкове поле"),
    }),
  ),
  syncConfiguration: Yup.object().shape({
    syncIntervalInMin: Yup.number().min(1, 'Мінімальне значення 1').required("Обов'язкове поле"),
    identitySaveInMonths: Yup.number().min(1, 'Мінімальне значення 1').required("Обов'язкове поле"),
  }),
  securityGates: Yup.array().of(
    Yup.object().shape(
      {
        id: Yup.number(),
        name: Yup.string()
          .min(1, "Обов'язкове поле") // @ts-ignore
          .uniqueField('securityGates')
          .when('isDeleted', {
            is: (isDeleted: boolean) => !isDeleted,
            then: Yup.string().required("Обов'язкове поле"),
          }),
        isDeleted: Yup.boolean(),
        peripheralRoles: Yup.array()
          .of(
            Yup.object().shape({
              peripheralHardwareId: Yup.number(),
              peripheralUrl: Yup.string(),
              processName: Yup.string().nullable(),
              allowedExitTolerance: Yup.number()
                .transform((value) => (isNaN(value) ? null : value))
                .nullable(),
              allowedExitTheoreticalTolerance: Yup.number()
                .transform((value) => (isNaN(value) ? null : value))
                .nullable(),
              allowableToleranceWithoutLoading: Yup.number()
                .transform((value) => (isNaN(value) ? null : value))
                .nullable(),
            }),
          )
          .when('isDeleted', {
            is: (isDeleted: boolean) => !isDeleted,
            then: Yup.array().of(
              Yup.object().shape({
                peripheralHardwareId: Yup.number().required("Обов'язкове поле"),
                peripheralUrl: Yup.string()
                  .matches(/^(?:http(s)?:\/\/)(...).*/, "Має бути посиланням ('http://...')")
                  .required("Обов'язкове поле"),
                processName: Yup.string().nullable(),
                allowedExitTolerance: Yup.number()
                  .transform((value) => (isNaN(value) ? null : value))
                  .nullable(),
                allowedExitTheoreticalTolerance: Yup.number()
                  .transform((value) => (isNaN(value) ? null : value))
                  .nullable(),
                allowableToleranceWithoutLoading: Yup.number()
                  .transform((value) => (isNaN(value) ? null : value))
                  .nullable(),
              }),
            ),
          }),
      },
      [
        ['isDeleted', 'peripheralRoles'],
        ['isDeleted', 'peripheralRoles.peripheralUrl'],
        ['isDeleted', 'peripheralUrl'],
      ],
    ),
  ),
  locations: Yup.array().of(
    Yup.object().shape(
      {
        id: Yup.number(),
        name: Yup.string()
          // @ts-ignore
          .uniqueField('locations')
          .when('isDeleted', {
            is: (isDeleted: boolean) => !isDeleted,
            then: Yup.string().required("Обов'язкове поле"),
          }),
        isDeleted: Yup.boolean(),
        configurations: Yup.array()
          .of(
            Yup.object().shape(
              {
                id: Yup.number(),
                isDeleted: Yup.boolean(),
                name: Yup.string().when('isDeleted', {
                  is: (isDeleted: boolean) => !isDeleted, // @ts-ignore
                  then: Yup.string().nullable().required("Обов'язкове поле").uniqueField('configurations'),
                }),
              },
              [['isDeleted', 'name']],
            ),
          )
          .when('isDeleted', {
            is: (isDeleted: boolean) => isDeleted,
            then: Yup.array().of(
              Yup.object().shape({
                id: Yup.number(),
                isDeleted: Yup.boolean(),
                name: Yup.string(),
              }),
            ),
          }),
      },
      [['isDeleted', 'configurations']],
    ),
  ),
  ordering: Yup.object().shape({
    peripheralRoles: Yup.array().of(
      Yup.object().shape({
        peripheralHardwareId: Yup.number().required("Обов'язкове поле"),
        peripheralUrl: Yup.string()
          .matches(/^(?:http(s)?:\/\/)?.*$/, "Має бути посиланням ('http://...')")
          .required("Обов'язкове поле"),
        processName: Yup.string().nullable(),
        allowedExitTolerance: Yup.number()
          .transform((value) => (isNaN(value) ? null : value))
          .nullable(),
      }),
    ),
  }),
  messageTemplates: Yup.object().shape({
    driverTemplates: Yup.array().of(
      Yup.object().shape({
        // @ts-ignore
        causeSendingMessageId: Yup.string().uniqueTemplates('driverTemplates').required("Обов'язкове поле"),
      }),
    ),
    clientTemplates: Yup.array().of(
      Yup.object().shape({
        // @ts-ignore
        causeSendingMessageId: Yup.string().uniqueTemplates('clientTemplates').required("Обов'язкове поле"),
      }),
    ),
    managerTemplates: Yup.array().of(
      Yup.object().shape({
        // @ts-ignore
        causeSendingMessageId: Yup.string().uniqueTemplates('managerTemplates').required("Обов'язкове поле"),
      }),
    ),
  }),
  screenRenderSettings: Yup.object().shape({
    frequency: Yup.number()
      .min(5, 'Мінімальна частота перемикання екрана має бути не менше 5 секунд')
      .integer('Частота перемикання екрана має бути цілим числом')
      .required("Обов'язкове поле"),
  }),
});

export default branchEditingSchema;
